/*
 * Copyright (c) 2023 Bluemate B.V.
 */

import React, {PureComponent} from 'react';

import {AdminContextShape, UpdateAdminContext} from '../../util/interfaces';

import {voidFunction} from '@dvrd/dvr-controls';

const defaultContext: AdminContextShape = {
    activeUser: null,
    activeAccount: null,
    onChangeContext: voidFunction
};

export const AdminContext = React.createContext(defaultContext);

interface State {
    context: AdminContextShape;
}

export default class AdminContextProvider extends PureComponent<any, State> {
    constructor(props: any) {
        super(props);
        this.state = {
            context: {
                activeUser: null,
                activeAccount: null,
                onChangeContext: this.onChangeContext
            }
        };
    }

    onChangeContext = (config: UpdateAdminContext, callback?: (context: AdminContextShape) => void) => {
        const context = this.getContext();
        const {user, account} = config;
        if (user !== undefined) context.activeUser = user;
        if (account !== undefined) context.activeAccount = account;
        this.setState({context}, () => {
            callback?.(context);
        });
    };

    getContext = () => ({...this.state.context});

    render = () => {
        const {context} = this.state;
        return <AdminContext.Provider value={context}>{this.props.children}</AdminContext.Provider>;
    };
}
